import { render, staticRenderFns } from "./ProjectsPage.vue?vue&type=template&id=08913fdc"
import script from "./ProjectsPage.vue?vue&type=script&lang=ts"
export * from "./ProjectsPage.vue?vue&type=script&lang=ts"
import style0 from "./ProjectsPage.vue?vue&type=style&index=0&id=08913fdc&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports